<form id="msform">
	<!-- pasos top -->
	<ul id="progressbar_pasos">
		<li *ngFor="let item of steps; let i = index" [ngClass]="{ active_paso: i <= currentStep }">
			<div class="icon_step"><img [src]="item.pathImage" /></div>
			<strong>{{ item.title }} </strong>
		</li>
	</ul>
	<!-- Fin pasos top -->

	<fieldset>
		<ng-content select="[step1]" *ngIf="currentStep + 1 === 1"></ng-content>
		<ng-content select="[step2]" *ngIf="currentStep + 1 === 2"></ng-content>
		<ng-content select="[step3]" *ngIf="currentStep + 1 === 3"></ng-content>
		<ng-content select="[step4]" *ngIf="currentStep + 1 === 4"></ng-content>

		<ng-container *ngIf="!hideButtons">
			<ng-container *ngIf="currentStep < steps.length - 1">
				<button
					*ngIf="currentStep > 0"
					type="button"
					name="previous"
					[ngClass]="{ '': invertButonColors, previous_paso: !invertButonColors }"
					(click)="back()"
				>
					ANTERIOR
				</button>
				<button
					[disabled]="disableButton"
					type="button"
					name="next"
					class="next_paso {{ styleClass }}"
					(click)="next()"
					[ngClass]="{
						btn_conf: currentStep + 1 === steps.length - 1,
						previous_paso: invertButonColors,
						next_paso: !invertButonColors
					}"
				>
					{{
						!avoidLogicTextButton
							? currentStep + 1 === steps.length - 1
								? textButtonSuccess
								: 'CONTINUAR'
							: textButtonSuccess
					}}
				</button>
			</ng-container>

			<ng-container *ngIf="showBack && currentStep + 1 === steps.length">
				<button type="button" name="close" class="button btn_regresar" (click)="closeModal()">REGRESAR</button>
			</ng-container>
			<ng-container *ngIf="showGoToInquiries && currentStep + 1 === steps.length">
				<button type="button" name="close" class="button btn_regresar" (click)="closeModal()">IR A CONSULTAS</button>
			</ng-container>
		</ng-container>
		<div class="content_alerts alerta_confirmacion" *ngIf="messageTransfer && currentStep === 0">
			<div class="alert alert_info">
				<span><img src="assets/images/alert_info.png" alt="info" /></span>
				<div class="info_bancos" [innerHtml]="messageTransfer"></div>
			</div>
		</div>
	</fieldset>
</form>
